import React from 'react';
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Box, Button, Container, Grid, Typography, useTheme, useMediaQuery } from '@mui/material';
import { teacherTrainingData } from "../../utils/BeadsData";

const TeacherTraining = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <NavBar />
            <Container sx={{ mt: 12, mx: 'auto', mb: 5 }}>
                <Typography variant="h3" gutterBottom sx={{ mt: isMobile ? 15 : 3, textAlign: 'center', fontWeight: 'bold' }}>Teachers Training</Typography>

                <Typography paragraph mt={5}>
                    BEADS is active in the front of the classroom, too. By helping teachers in Kenya, we can improve the lives of a generation of students.
                </Typography>

                <Grid container spacing={5} justifyContent="center" sx={{ mt: 1 }}>
                    <Grid item xs={12} md={8}>
                        <Swiper
                            modules={[Autoplay, EffectFade]}
                            effect="fade"
                            autoplay={{ delay: 5000, disableOnInteraction: false }}
                            loop={true}
                            style={{ borderRadius: '2rem' }}
                        >
                            {teacherTrainingData.map((image, index) => (
                                <SwiperSlide key={index}>
                                    <Box sx={{ position: 'relative', height: isMobile ? 250 : 450 }}>
                                        <img src={image.src} alt={image.alt}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        <Typography
                                            variant={isMobile ? "body2" : "subtitle1"}
                                            sx={{
                                                position: 'absolute',
                                                bottom: 0,
                                                width: '100%',
                                                color: 'white',
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                padding: '6px',
                                                textAlign: 'center',
                                                fontSize: isMobile ? '0.75rem' : '1rem',
                                            }}
                                        >
                                            {image.description}
                                        </Typography>
                                    </Box>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Grid>

                    <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: isMobile ? 3 : 15 }}>
                        <Box sx={{ width: '100%', p: 3, textAlign: 'center', borderRadius: '1.5rem', background: '#f8fafd', border: '1px solid #cfcfcf' }}>
                            <Typography variant="body1" paragraph>
                                PLEASE HELP IMPROVE EDUCATION FOR OUR KENYAN STUDENTS...
                            </Typography>
                            <Typography variant="body1" paragraph>
                                MAKE A DONATION TODAY.
                            </Typography>
                            <Button className='btn btn-border-base' variant="outlined" onClick={() => navigate('/donate')} sx={{ mt: 2, borderRadius: 15 }}>
                                Learn More
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Container>


            <Container sx={{ my: 3 }}>
                <Typography paragraph sx={{ textAlign: 'center', mx: 'auto', width: '100%' }}>
                    BEADS strives to improve the quality of teaching in our sponsored schools with our teacher training and intern program. Most teaching in Kenya is based on memorization and repetition. Our goal is to create critical thinkers and ultimately the next generation of Kenyan leaders.
                </Typography>
            </Container>

            <FooterOne />
        </Box>
    );
};

export default TeacherTraining;